import React from 'react';
export function Footer() {
  return <footer className="w-full bg-black border-t border-[#00C853]/20 py-10 px-4" data-id="element-214">
      <div className="max-w-3xl mx-auto text-center" data-id="element-215">
        <div className="text-[#00C853] text-2xl font-black tracking-widest mb-4" data-id="element-216">
          ⚽ PROFEPACK™
        </div>
        <p className="text-gray-400 text-sm leading-relaxed mb-4 max-w-xl mx-auto" data-id="element-217">
          El sistema de formación N°1 para profes de Baby Fútbol en Argentina.
        </p>
        <p className="text-gray-400 text-sm italic mb-6" data-id="element-218">
          Porque entrenar Baby Fútbol no debería costarte todos los domingos del
          año.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 text-sm text-gray-300 mb-6" data-id="element-219">
          <span data-id="element-220">📧 soporteprofepack@gmail.com</span>
          <span className="hidden sm:inline" data-id="element-221">•</span>
          <span data-id="element-222">📲 @profepack</span>
          <span className="hidden sm:inline" data-id="element-223">•</span>
          <span data-id="element-224">🌐 www.profepack.com</span>
        </div>

        <div className="h-px bg-[#00C853]/20 mb-6" data-id="element-225" />
        <p className="text-gray-400 text-xs mb-2" data-id="element-226">
          © ProfePack™ 2025 — Todos los derechos reservados.
        </p>
        <p className="text-gray-500 text-xs mb-6" data-id="element-227">
          Prohibida la reproducción y redistribución sin autorización expresa.
        </p>
        <p className="text-gray-500 text-xs font-bold tracking-widest" data-id="element-228">
          "El próximo domingo puede ser diferente."
        </p>
      </div>
    </footer>;
}